import { RefObject, useEffect, useState } from 'react';

export const useKeyPressed = (ref: RefObject<HTMLDivElement>) => {
  const [keysPressed, setKeysPressed] = useState<Set<string>>(new Set());

  const handleKeyDown = (event: KeyboardEvent) => {
    setKeysPressed((prev) => new Set([...prev, event.key]));
  };

  const handleKeyUp = (event: KeyboardEvent) => {
    setKeysPressed((prev) => {
      const newSet = new Set(prev);
      newSet.delete(event.key);
      return newSet;
    });
  };

  useEffect(() => {
    const currentRef = ref.current;
    if (!currentRef) {
      return undefined;
    }

    currentRef.addEventListener('keydown', handleKeyDown);
    currentRef.addEventListener('keyup', handleKeyUp);

    return (): void => {
      currentRef.removeEventListener('keydown', handleKeyDown);
      currentRef.removeEventListener('keyup', handleKeyUp);
    };
  }, [ref]);

  return { keysPressed };
};
